export class UnexpectedError extends Error {
  private static NAME: string = 'UnexpectedError'
  public static MESSAGE: string = 'Algo de errado aconteceu. Tente novamente em breve.'

  constructor(message?: string | null) {
    super(message || UnexpectedError.MESSAGE)
    this.name = UnexpectedError.NAME
  }

  static Response = {
    statusCode: 500,
    body: {
      success: false,
      data: null,
      message: UnexpectedError.MESSAGE
    }
  }
}
